import React from "react";
import Meta from "../components/Meta";
import Section from "../components/Section";

function PrivacyPolicy() {
  return (
    <>
      <Meta title="Privacy Policy - SMSushi" />
      <Section
        size="md"
        bgColor="bg-white"
        bgImage=""
        bgImageOpacity={1}
        textColor=""
      >
        <div className="container mx-auto px-4 sm:px-6 py-8">
          <h1 className="text-3xl font-bold mb-6">Privacy Policy</h1>
          
          <div className="prose max-w-3xl">
            <p className="mb-4">Last Updated: {new Date().toLocaleDateString()}</p>
            
            <h2 className="text-xl font-semibold mt-8 mb-4">Introduction</h2>
            <p>
              At SMSushi, we respect your privacy and are committed to protecting your personal data. 
              This privacy policy will inform you about how we handle your personal information when 
              you use our service to make restaurant reservations.
            </p>
            
            <h2 className="text-xl font-semibold mt-8 mb-4">What Information We Collect</h2>
            <p>
              When you make a reservation through our service, we collect:
            </p>
            <ul className="list-disc pl-6 mb-4">
              <li>Your name</li>
              <li>Your email address</li>
              <li>Your phone number</li>
              <li>Reservation details (date, time, party size)</li>
            </ul>
            
            <h2 className="text-xl font-semibold mt-8 mb-4">How We Use Your Information</h2>
            <p>
              <strong>Your email address is only used to send you a reminder email on the morning of your reservation.</strong> 
              We do not use your email for marketing purposes, we do not sell your data to third parties, 
              and we do not use your information for any other purpose than facilitating your reservation.
            </p>
            
            <h2 className="text-xl font-semibold mt-8 mb-4">Data Storage and Security</h2>
            <p>
              Your reservation information is stored securely in our database. We implement appropriate 
              technical and organizational measures to protect your personal data against unauthorized or 
              unlawful processing, accidental loss, destruction, or damage.
            </p>
            
            <h2 className="text-xl font-semibold mt-8 mb-4">Data Retention</h2>
            <p>
              We retain your reservation data for a limited period after your reservation date for 
              administrative purposes. After this period, your data is securely deleted from our systems.
            </p>
            
            <h2 className="text-xl font-semibold mt-8 mb-4">Your Rights</h2>
            <p>
              You have the right to:
            </p>
            <ul className="list-disc pl-6 mb-4">
              <li>Access your personal data</li>
              <li>Correct inaccurate personal data</li>
              <li>Request the deletion of your personal data</li>
              <li>Object to processing of your personal data</li>
              <li>Request restriction of processing your personal data</li>
              <li>Request transfer of your personal data</li>
            </ul>
            
            <h2 className="text-xl font-semibold mt-8 mb-4">Third-Party Services</h2>
            <p>
              We use Firebase services for hosting and database management. Firebase's privacy policy 
              can be viewed at <a href="https://firebase.google.com/support/privacy" className="text-blue-600 hover:underline">https://firebase.google.com/support/privacy</a>.
            </p>
            
            <h2 className="text-xl font-semibold mt-8 mb-4">Changes to This Privacy Policy</h2>
            <p>
              We may update our Privacy Policy from time to time. We will notify you of any changes by 
              posting the new Privacy Policy on this page and updating the "Last Updated" date.
            </p>
            
            <h2 className="text-xl font-semibold mt-8 mb-4">Contact Us</h2>
            <p>
              If you have any questions about this Privacy Policy, please contact us:
            </p>
            <ul className="list-disc pl-6 mb-4">
              <li>By email: <a href="mailto:sanmateosushi.reservations@gmail.com" className="text-blue-600 hover:underline">sanmateosushi.reservations@gmail.com</a></li>
              <li>By phone: <a href="tel:650-344-0888" className="text-blue-600 hover:underline">650-344-0888</a></li>
            </ul>
          </div>
        </div>
      </Section>
    </>
  );
}

export default PrivacyPolicy; 